import React, { useEffect, useState } from "react";

import "./Whistlist.css";

const Whistlist = ({ whistlist }) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const totalAmount = whistlist
      .map((item) => item.price)
      .reduce((a, b) => a + b, 0);

    setTotal(totalAmount);
  }, [whistlist]);

  return (
    <div className="whistlist-parent">
      <div className="whistlist">
        <h2>Whistlist</h2>
        <p>Total Comic Listed: {whistlist.length} </p>
        <p>Total Comic Price: {total} </p>
      </div>
      <div className="whistlist-item">
        {whistlist.map((item) => (
          <p key={item.id}>{item.title}</p>
        ))}
      </div>
    </div>
  );
};

export default Whistlist;
